import React from 'react'
import { Container, Stack, Theme } from '@mui/material'
import { Zoom } from 'react-awesome-reveal'
import MapImagePng from 'images/wholesale/010@4x.png'
import MapMobileImagePng from 'images/wholesale/016@4x.png'
import makeStyles from '@mui/styles/makeStyles'
import { Link } from 'react-router-dom'
import { WHOLESALE_ROUTES } from '../../../../urls'
import { useMarketingInfoQuery } from '@graphql/queries/__generated__/marketing-info.generated'
import { SITE_NAME } from '../../../../../constants'
import { Trans, useTranslation } from 'react-i18next'

const BUTTON_COLOR = '#F0AE16'

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    backgroundColor: '#F2EEEA',
    [theme.breakpoints.down('md')]: {
      backgroundColor: '#D9E9EF',
    },
  },
}))

const MapSection: React.FC = () => {
  const { t } = useTranslation()
  const { data } = useMarketingInfoQuery({
    variables: { salesChannelName: 'etsy' },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  const classes = useStyles()
  const COUNTRIES = [
    [t('UnitedStates', 'United States'), t('UnitedKingdom', 'United Kingdom'), t('Canada', 'Canada')],
    [t('Australia', 'Australia'), t('France', 'France'), t('Netherlands', 'Netherlands')],
    [t('NewZeeland', 'New Zeeland'), t('Germany', 'Germany'), t('Spain', 'Spain')],
    [t('India', 'India'), t('Czechia', 'Czechia'), t('HongKong', 'Hong Kong')],
    [t('Turkey', 'Turkey'), t('Belgium', 'Belgium'), t('wholesale.andSoOn', 'and so on')],
  ]
  return (
    <section className={`py-30 text-center overflow-hidden ${classes.section}`}>
      <Container maxWidth='lg'>
        <div className='p-40 rounded-4xl hidden md:block' style={{ backgroundColor: '#C6DEE7' }}>
          <Zoom triggerOnce direction='up' delay={100}>
            <div className='max-w-full'>
              <img src={MapImagePng} alt='Map' className='w-full' draggable={false} />
            </div>
          </Zoom>
          <h2 className='text-5xl mt-40 mb-40'>
            {t('wholesale.awesomeCustomerGeography', 'Awesome Customer Geography')}
          </h2>
          <Stack className='leading-normal max-w-1000 mx-auto' direction='row' spacing={1}>
            {COUNTRIES.map((row, idx) => {
              return (
                <div key={idx} className='w-full text-lg'>
                  {row.map(country => (
                    <div key={country} className='mb-10'>
                      {country}
                    </div>
                  ))}
                </div>
              )
            })}
          </Stack>
        </div>
        <div className='block md:hidden'>
          <Zoom triggerOnce direction='down' delay={100}>
            <div className='max-w-full'>
              <img src={MapMobileImagePng} alt='Map mobile' className='w-full' draggable={false} />
            </div>
          </Zoom>
          <div className='flex justify-center'>
            <h2 className='text-lg mt-20 mb-10 w-full leading-snug'>
              {t('wholesale.aboutOurShop', {
                defaultValue:
                  '{{siteName}} is one of the best and most successful shops offering high-quality, unique designs and materials for the modern crafter. Check us out on the global online marketplace for handmade goods, ',
                siteName: SITE_NAME,
              })}

              <a href='https://www.etsy.com/shop/awesomepatternstudio' target='_blank'>
                Etsy.com
              </a>
            </h2>
          </div>

          <p className='text-center text-base leading-relaxed'>
            <Trans
              i18nKey='wholesale.ourShopSales'
              defaults={`Established in 2017 <br/>More than {{salesCount}} sales <br />More than {{positiveFeedbackCount}} positive 5-star reviews <br />and we just keep going…`}
              values={{
                salesCount: data?.marketingInfo.salesCount,
                positiveFeedbackCount: data?.marketingInfo.positiveFeedbackCount,
              }}
              components={{ br: <br /> }}
            />
          </p>
        </div>
        <div className='mt-20 md:mt-50 block md:hidden'>
          <Link
            className={`inline-block py-14 px-5 text-xl no-underline w-300 max-w-full text-center`}
            style={{ backgroundColor: BUTTON_COLOR, borderRadius: '30px' }}
            to={WHOLESALE_ROUTES.REGISTRATION}
          >
            {t('button.becomeAPartner', 'Become a partner')}
          </Link>
        </div>
      </Container>
    </section>
  )
}

export default MapSection
